import {kijs} from '../config';
import Map from 'ol/Map';
import View from 'ol/View';
import Vector from 'ol/layer/Vector';
import OSM from 'ol/source/OSM';
import {defaults as defaultControls} from 'ol/control';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';

//import {setLastActionTime} from '../sessionTime/actions';

//import {wmsLayer, wmsBWLayer} from '../baseLayers/map';

var view = new View({
    center: [2683184, 7749797],
    zoom: 8,
    maxZoom: 18,
    minZoom: 2, //11 / 6
    projection: 'EPSG:3857',
//  extent: [2767119,7781461, 2829119,7893591]
});



 var map = new Map({

//  renderer: 'webgl',
    crossOrigin: 'anonymous',
    layers: [
    //  wmsBWLayer
    ],
    controls: defaultControls({attribution: false}),
/*  controls:[
        new ol.control.Attribution(),
        new ol.control.Rotate(),
        new ol.control.ScaleLine(),
        new ol.control.FullScreen({tipLabel:'Pilnekrāna režīms'}),
    //  mouseControl
    ],*/
    view: view,
    logo: false
});

map.on('pointermove', (e)=>{
    var hit = map.forEachFeatureAtPixel(e.pixel, function(feature, moveLayer) {
        
        return true;
        
    }); 
    if (hit) {
        map.getTargetElement().style.cursor = 'pointer';
    } else {
        map.getTargetElement().style.cursor = '';
    }
})

var dblClickInteraction;
// find DoubleClickZoom interaction
map.getInteractions().getArray().forEach(function(interaction) {
  if (interaction instanceof DoubleClickZoom) {
    dblClickInteraction = interaction;
  }
});
// remove from map
map.removeInteraction(dblClickInteraction);

/*
var mousePosition = new ol.control.MousePosition({
    coordinateFormat: ol.coordinate.createStringXY(6),
    projection: 'EPSG:4326',
});

map.addControl(mousePosition);*/

var mapIni = function(store) {

    /*Inicializējam karti*/
    map.setTarget(document.getElementById('map'));

    map.on('moveend', () => {

    //  store.dispatch(setLastActionTime());
    });
}

export {mapIni, map}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/map.js